import React, { useEffect, useState } from 'react'
import { postAPI } from '../../app/api';
import { store, setStore } from '../../app/store';
import ComingSoonImg from "../../theme/assets/img/illustrations/page-misc-launching-soon.png";

export default function ComingSoon() {
  return (
    <div class="container-xxl container-p-y text-center">
      <div class="misc-wrapper">
        <h2 class="mb-1 mx-2">We are launching soon</h2>
        <p class="mb-4 mx-2">We're creating something awesome. Please subscribe to get notified when it's ready!</p>
        <form onsubmit="return false" class="mb-4">
          <div class="mb-0  d-flex align-items-center justify-content-center">
            <div class="input-group" style={{width: "300px"}}>
              <input type="text" class="form-control" placeholder="email" autofocus="" />
              <button type="submit" class="btn btn-primary waves-effect waves-light">Notify</button>
            </div>
          </div>
        </form>
        <div class="mt-4">
          <img src={ComingSoonImg} alt="page-misc-launching-soon" width="263" class="img-fluid" />
        </div>
      </div>
    </div>
  )
}
